import React, { useState } from 'react';
import useHandleErrorFields from '../../../hooks/useHandleErrorFields';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useAuthService from '../../../app/services/hooks/useAuthService';
import { toast } from 'react-toastify';
import InputField from '../../../components/InputField';

type Props = {
    email: string;
    setChangePassword: (setChangePassword: boolean) => void;
};

const recoveryPasswordForm = ({ email, setChangePassword }: Props) => {
    const { fieldErrorMessage, onFocusRemove, setErrors } = useHandleErrorFields();
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [codeRecoveryPassword, setCodeRecoveryPassword] = useState('');
    const { changePasswordByCode } = useAuthService();

    const onClickChangePassword = () => {
        changePasswordByCode(email, codeRecoveryPassword, password, repeatPassword, {
            onSuccess: (response: ServiceResponse) => {
                setChangePassword(true);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            },
            onFieldError: (response: ServiceResponse) => {
                setErrors(response.data);
            }
        });
    };

    return (
        <div className="recovery-form">
            <InputField
                type="text"
                label="Código de verificación"
                value={codeRecoveryPassword}
                onChange={setCodeRecoveryPassword}
                onFocus={() => onFocusRemove('code_recovery_password')}
                placeholder="Ingrese el código recibido"
                error={fieldErrorMessage('code_recovery_password')}
                icon="fas fa-key"
                backgroundColor="#FAFBFC"
                required
            />

            <InputField
                type="password"
                label="Nueva contraseña"
                value={password}
                onChange={setPassword}
                onFocus={() => onFocusRemove('password')}
                placeholder="Ingrese su nueva contraseña"
                error={fieldErrorMessage('password')}
                icon="fas fa-lock"
                backgroundColor="#FAFBFC"
                required
            />

            <InputField
                type="password"
                label="Confirmar contraseña"
                value={repeatPassword}
                onChange={setRepeatPassword}
                onFocus={() => onFocusRemove('repeat_password')}
                placeholder="Confirme su nueva contraseña"
                error={fieldErrorMessage('repeat_password')}
                icon="fas fa-lock"
                backgroundColor="#FAFBFC"
                required
            />

            <button
                onClick={onClickChangePassword}
                type="button"
                className="btn-recovery"
            >
                <span>Cambiar Contraseña</span>
                <i className="fas fa-save"></i>
            </button>
        </div>
    );
};

export default recoveryPasswordForm;
